import { render, staticRenderFns } from "./UserPermissionsView.html?vue&type=template&id=0bf89b92&scoped=true&external"
import script from "./UserPermissionsView.js?vue&type=script&lang=js&external"
export * from "./UserPermissionsView.js?vue&type=script&lang=js&external"
import style0 from "./UserPermissionsView.scss?vue&type=style&index=0&id=0bf89b92&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf89b92",
  null
  
)

export default component.exports